import { createAction } from 'redux-actions'

/* --------- ui --------- */
export const setModalVisibility = createAction('MODAL_VISIBILITY_SET')

/* --------- company --------- */
export const setCompanyHierarchy = createAction('COMPANY_HIERARCHY_SET')
export const setCompanyReferences = createAction('COMPANY_REFERENCES_SET')
export const setCompanyDiseases = createAction('COMPANY_DISEASES_SET')
export const setCompanyCaseManagers = createAction('COMPANY_CASE_MANAGERS_SET')
export const setCompanyMeasurements = createAction('SET_COMPANY_MEASUREMENTS')
export const setCompanyEmployees = createAction('SET_COMPANY_EMPLOYEES')

/* --------- user --------- */
export const setNoInternetConnection = createAction(
  'SET_NO_INTERNET_CONNECTION'
)
/* --------- patient --------- */
export const setDiagnosisList = createAction('SET_DIAGNOSIS_LIST')
export const setDiagnosisLoading = createAction('SET_DIAGNOSIS_LOADING')

export const setPatientProfile = createAction('PATIENT_DETAILS_SET')
export const setPatientProfileIsLoading = createAction(
  'PATIENT_DETAILS_LOADING_SET'
)
export const setPatientLatestRisk = createAction('PATIENT_LATEST_RISK_SET')
export const setPatientRiskRecalculated = createAction(
  'PATIENT_RISK_RECALCULATED'
)
export const setActiveEnrolledProgram = createAction(
  'ACTIVE_ENROLLED_PROGRAM_SET'
)
export const setNextCarePlanReviewDate = createAction(
  'SET_NEXT_CARE_PLAN_REVIEW_DATE'
)

export const deletePatientData = createAction('PATIENT_DATA_DELETE')

export const setActivePatientEnrolledProgram = createAction(
  'PATIENT_ACTIVE_ENROLLED_PROGRAM_SET'
)
export const setCourses = createAction('COURSES_SET')
export const setNewCourses = createAction('NEW_COURSES_SET')
export const deleteCourses = createAction('COURSES_DELETE')
export const activateCourse = createAction('COURSE_ACTIVATED')
export const inactivateCourse = createAction('COURSE_INACTIVATED')

export const setAlertTypes = createAction('ALERT_TYPES_SET')

export const setUnreadMessagesCount = createAction(
  'CHATS_UNREAD_MESSAGES_COUNT_SET'
)
export const setPatientUuidChat = createAction('SET_PATIENT_UUID_CHAT')
export const setPatientTotalChatMessages = createAction(
  'SET_PATIENT_TOTAL_CHAT_MESSAGES'
)

export const setAlertsPriorityCount = createAction('SET_ALERT_PRIORITY_COUNT')
export const clearAlertsPriorityCount = createAction(
  'CLEAR_ALERTS_PRIORITY_COUNT'
)

export const setPatientAlertList = createAction('SET_PATIENT_ALERT_LIST')

export const setIsAlertRedirectFromDashboard = createAction(
  'SET_IS_ALERT_REDIRECT_FROM_DASHBOARD'
)
export const setAlertPredefinedFilters = createAction(
  'SET_ALERT_PREDEFINED_FILTERS'
)

export const setIsCoursesRedirectFromDashboard = createAction(
  'SET_IS_COURSES_REDIRECT_FROM_DASHBOARD'
)
export const setRedirectedCourseUuid = createAction(
  'SET_REDIRECTED_COURSE_UUID'
)

export const setPatientReadingAnswers = createAction(
  'SET_PATIENT_READING_ANSWERS'
)

export const setPatientDiseases = createAction('SET_PATIENT_DISEASES')
export const setPatientDiseasesLoading = createAction(
  'SET_PATIENT_DISEASES_LOADING'
)
export const setPatientDiseaseModalLoading = createAction(
  'SET_PATIENT_DISEASE_MODAL_LOADING'
)
export const setIsDashboard = createAction('SET_IS_DASHBOARD')

export const setFollowUpCall = createAction('SET_FOLLOW_UP_CALL')
export const setPatientMedicalDevices = createAction(
  'SET_PATIENT_MEDICAL_DEVICES'
)

export const resetAlerts = createAction('RESET_ALERTS')

export const setPatientDiagnosis = createAction('SET_PATIENT_DIAGNOSIS')
export const setPatientDiagnosisLoading = createAction(
  'SET_PATIENT_DIAGNOSIS_LOADING'
)
export const setPatientDiagnosisModalLoading = createAction(
  'SET_PATIENT_DIAGNOSIS_MODAL_LOADING'
)

export const setPatientOnHoldHistory = createAction(
  'SET_PATIENT_ON_HOLD_HISTORY'
)

export const setPatientRpmBillableHistory = createAction(
  'SET_PATIENT_RPM_BILLABLE_HISTORY'
)

export const setAlertPatientUuid = createAction('SET_ALERT_PATIENT_UUID')

export const setPatientLastTelemedicineCall = createAction(
  'SET_PATIENT_LAST_TELEMEDICINE_CALL'
)

export const setIsCommunicationShowAll = createAction(
  'SET_IS_COMMUNICATION_SHOW_ALL'
)
